import script from "./ProjectsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=3aa3ad22&lang=scss"

const __exports__ = script;

export default __exports__